import React from "react";

const CMSRow = () => {
    return (
        <div className="cms-breadcrumb">
            <div className='cms-breadcrumb-text'>
                <p className="cms-breadcrumb-paragraph">Welcome</p>
            </div>
        </div>
    );
}

export default CMSRow;

